import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/makeup-editor"
    exact
    path="/consumer/features/makeup-editor"
    component={AsyncPage}
  />,
];
